// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1y05y","content":"styles_content__jvHhn","margin":"styles_margin__3JhmC"};